<template>
	<div>
		<div style="height:5rem;text-align: left;">
			<h1 style="margin-left: 20rem;font-size: 3rem;">产品中心</h1>
		</div>
		<hr>
		<div style="margin-top: 1rem;">
			<el-tabs type="border-card" @tab-click="handleClick"
				style="width: 90rem;margin-left: 15rem;height: 50rem;border-radius:1%;">
				<el-tab-pane v-for="(tpItem,tpIndex) in device_type" :key="tpIndex" label="tpItem.id">
					<span slot="label" style="font-size: 1.5rem;">{{ tpItem.typeName }}</span>
					<el-tabs tab-position="left" @tab-click="handle2Click" lazy="true">
						<el-tab-pane v-for="(item,index) in devices" :key="index" label="item.id">
							<span slot="label" style="font-size:1.2rem;">{{ item.name }}</span>
						</el-tab-pane>

						<div style="overflow:auto;height: 42rem;">
							<el-carousel type="card" indicator-position="none" height="42rem"
								style="background-color: #fff; ">
								<el-carousel-item v-for="item in device_more.picturesList" :key="item.id"
									style="background-color: #fff; ">
									<el-image style="height: 42rem;background-color: #fff; " :src="item.picturePath"
										fit="contain" :preview-src-list="srcPicturesList"></el-image>

								</el-carousel-item>
							</el-carousel>
							<!-- 							
							<div style="overflow:auto;height: 42rem;">
								<h3 style="font-size: 3rem;" v-model="device_more.textsList">
									{{device_more.textsList[0].title}}
								</h3>
								<h3 style="font-size: 2rem;white-space: pre-wrap" v-model="device_more.textsList">
										{{device_more.textsList[0].content}}
								</h3>
							</div>
							 -->


						</div>


					</el-tabs>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div
			style="width: 100%;height: 10rem;background-color: black;position: absolute;z-index: 1;margin-top:1rem;overflow: hidden;text-align: center;">
			<div style="color: gray;float: left;margin-left: 46.5rem;margin-top: 1rem;">
				联系我们 : 0411-87588091&nbsp;0411-87588320&nbsp;13942048140&nbsp;<br>
				辽ICP备2023010852号-1
			</div>

			<div style="margin-left: 19rem; height: 7rem;width: 7rem;float: left;color: gray; margin-top: 0.6rem;">
				<img src="../assets/image/gongzhonghao.jpg" height="100%" width="100%" title="微信公众号">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Second',
		props: {
			msg: String
		},
		data() {
			return {
				device_type: {},
				device_more: {
					deviceTypeId: 1,
					id: 1,
					name: "手持激光甲烷遥测仪",
					linkList: [{
						id: 1,
						textId: 1,
						pictureId: 1,
						deviceId: 1
					}],
					textsList: [{
						id: 1,
						title: "未选择设备",
						content: "该设备暂无描述"
					}],
					picturesList: [{
						id: 1,
						picturePath: "http://114.116.47.165:12345/zwtp.png"
					}]
				},
				srcPicturesList: [],

				deviceKey: {
					id: "",
					name: null,
					deviceTypeId: ""
				},
				devices: [],
				zmd: [{
						path: "http://114.116.47.165:12345/zmd1.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd2.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd3.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd4.png"
					},
				]

			};
		},
		mounted() {
			this.http.get({
				url: "/device-type/list",
			}).then((data) => {
				this.device_type = data;
				this.deviceKey.deviceTypeId = this.device_type[0].id;
			}).then(() => {
				console.log(this.deviceKey)
				this.http.get({
					url: "/device/list",
					param: this.deviceKey,
				}).then((data) => {
					this.devices = data;

					console.log(this.devices)

					this.deviceKey.id = this.devices[0].id;
					this.deviceKey.name = this.devices[0].name;
					this.deviceKey.deviceTypeId = this.devices[0].deviceTypeId;
					console.log(this.deviceKey)
					console.log(this.device_more)
					this.http.post({
						url: "/device/listMore",
						param: this.deviceKey,
					}).then((data) => {
						// console.log(data)
						console.log("this.device_more1")
						console.log(this.device_more)

						this.device_more = {};
						this.device_more = data;
						console.log(this.device_more);

						this.srcPicturesList = [];
						for (var i = 0; i <= data.picturesList.length - 1; i++) {
							// console.log(data.picturesList[i])
							// console.log(data.picturesList[i].picturePath)
							this.srcPicturesList.push(data.picturesList[i].picturePath);
						}
						// console.log(this.srcPicturesList)

					})


				})
			})
		},
		methods: {
			handleClick(tab) {
				this.devices = []
				console.log(tab.index);
				this.deviceKey.id = "";
				this.deviceKey.name = null;
				this.deviceKey.deviceTypeId = parseInt(tab.index) + 1;
				this.http.get({
					url: "/device/list",
					param: this.deviceKey,
				}).then((data) => {
					console.log(data)
					this.devices = data;

					console.log(this.devices)

					this.deviceKey.id = this.devices[0].id;
					this.deviceKey.name = this.devices[0].name;
					this.deviceKey.deviceTypeId = this.devices[0].deviceTypeId;
					console.log(this.deviceKey)
					console.log(this.device_more)
					this.http.post({
						url: "/device/listMore",
						param: this.deviceKey,
					}).then((data) => {
						// console.log(data)
						console.log("this.device_more1")
						console.log(this.device_more)

						this.device_more = {};
						this.device_more = data;
						console.log(this.device_more);

						this.srcPicturesList = [];
						for (var i = 0; i <= data.picturesList.length - 1; i++) {
							// console.log(data.picturesList[i])
							// console.log(data.picturesList[i].picturePath)
							this.srcPicturesList.push(data.picturesList[i].picturePath);
						}
						// console.log(this.srcPicturesList)

					})

				})
			},
			handle2Click(tab) {

				// console.log(tab)
				console.log(this.devices)
				// console.log(this.devices[ parseInt(tab.index)])
				this.deviceKey.id = this.devices[parseInt(tab.index)].id;
				this.deviceKey.name = this.devices[parseInt(tab.index)].name;
				this.deviceKey.deviceTypeId = this.devices[parseInt(tab.index)].deviceTypeId;
				console.log(this.deviceKey)
				console.log(this.device_more)
				this.http.post({
					url: "/device/listMore",
					param: this.deviceKey,
				}).then((data) => {
					// console.log(data)
					console.log("this.device_more1")
					console.log(this.device_more)

					this.device_more = {};
					this.device_more = data;
					console.log(this.device_more);

					this.srcPicturesList = [];
					for (var i = 0; i <= data.picturesList.length - 1; i++) {
						// console.log(data.picturesList[i])
						// console.log(data.picturesList[i].picturePath)
						this.srcPicturesList.push(data.picturesList[i].picturePath);
					}
					// console.log(this.srcPicturesList)

				})


			},

		}
	}
</script>

<style>
	#app {
		background-color: white;
	}

	hr {
		border: 0;
		height: 0.6rem;
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(11, 11, 11, 0.75), rgba(0, 0, 0, 0));
	}

	.el-tabs__item {
		height: 4rem !important;
		line-height: 4rem !important;
		margin-bottom: -0.15rem;
	}

	.el-tabs__nav-scroll {
		overflow-y: scroll !important;
		scrollbar-width: none;
		-ms-overflow-style: none;
	}

	.el-tabs--border-card>.el-tabs__header {
		border-radius: 6%;
	}

	.el-tabs--left .el-tabs__header.is-left {
		height: 43rem !important;
		width: 22rem;
	}

	.element::-webkit-scrollbar {
		width: 0 !important
	}

	.is-top {
		overflow: hidden !important;
	}
</style>